import { render } from "./CoachFilter.vue?vue&type=template&id=cbd56108&scoped=true"
import script from "./CoachFilter.vue?vue&type=script&lang=js"
export * from "./CoachFilter.vue?vue&type=script&lang=js"

import "./CoachFilter.vue?vue&type=style&index=0&id=cbd56108&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd56108"]])

export default __exports__